import classNames from "classnames";
import { DotsClassNames } from "dots-ui/components/types";
import { DropdownChangeEvent } from "dots-ui/dotsDropDown";
import { FormikProps } from "formik";
import { useContext } from "react";
import { IFilterTypeValue, stringFilterOptions } from "../../../../models";
import { AvisContext } from "../../context/AvisContext";
import { AvisDropdown } from "./AvisDropdown";

interface IProps<T> {
  bag?: FormikProps<T>;
  bagFieldFilterType: keyof T;
  className?: DotsClassNames;
  disabled?: boolean;
}

export function AvisPrefixDropdown<T = object>(props: Readonly<IProps<T>>) {
  const { bag, bagFieldFilterType, disabled } = props;
  const { res } = useContext(AvisContext);
  const filterValues = stringFilterOptions(res);

  const onFilterTypeChange = (e: DropdownChangeEvent) => {
    bag?.setFieldValue(bagFieldFilterType as string, e.target.value);
  };

  const className = classNames(
    "avis-dropdown-select-filter-type",
    props.className,
  );

  return (
    <AvisDropdown<IFilterTypeValue, T>
      className={className}
      bag={bag}
      bagField={bagFieldFilterType}
      onChange={onFilterTypeChange}
      options={filterValues}
      optionLabel="title"
      optionValue="value"
      hideClear
      inputStyle="none"
      disabled={disabled}
    />
  );
}
